import { uploadFileToS3 } from "api/media-library/upload-file-to-s3";
import { Post } from "./types";

export function creatingPostNeedUploadCover(post: Post) {
  return (
    (post?.videoCoverImageTimestamp ?? 0) > 0 &&
    Boolean(post?.videoCoverPreview)
  );
}

export function editingPostNeedUploadCover(
  currentPost: Post,
  previousPost: Post
) {
  return (
    currentPost.videoCoverPreview &&
    currentPost.videoCoverImageTimestamp &&
    currentPost.videoCoverImageTimestamp > 0 &&
    currentPost.videoCoverImageTimestamp !==
      previousPost?.videoCoverImageTimestamp
  );
}

export async function getUpdateThumbnail(currentPost: Post) {
  if (!currentPost.videoCoverPreview) {
    return currentPost?.thumbnailUrl;
  }

  return fetch(currentPost.videoCoverPreview)
    .then((res) => res.blob())
    .then((blob) =>
      uploadFileToS3({
        blob,
        fileName: `${currentPost?._id}-video_cover_${Date.now()}.png`,
      })
    )
    .catch(() => currentPost?.thumbnailUrl);
}
